module.exports = __webpack_public_path__ + "static/media/aiload.0ac274e5.gif";